import { FenixA319MarketingSeo } from "../../../content/templateMarketing/fenix-a320-seo";
import { AircraftAddonTemplate } from "../../../lib/model/addonTemplate";
import fenixA319Image from "../../images/templates/fenix-a319.png";

import { fenixA320Template } from "./fenix-a320";

export const fenixA319Template: AircraftAddonTemplate = {
  ...fenixA320Template,
  title: "Fenix A319",
  id: "fenix-a319",
  image: fenixA319Image,
  infoMarketingBlurb: FenixA319MarketingSeo,
};
